/**
 * relation-graph-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { MessageRelationEdge, MessageRelationNode }
  from "../../../subjects/relation-graph";
import { validateAs, validateFor, validateOpaqueID }
  from "../../validation/decorators";

import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

/**
 * Server response containing a graph of the relationship network for a node.
 * NOTE: That the node (or expansion) that was originally requested is not
 * marked preferentially in any way by the result.
 */
@validateFor(MessageTag.RSP_RELATION_GRAPH)
export class RelationGraphResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_RELATION_GRAPH;

  /**
   * The server's ID of this graph in memory. The server must hold on to graphs
   * as they are explored to keep subject references, remember what nodes have
   * been visited, and keep the graph snapshot consistent.
   */
  @validateOpaqueID()
  public objectId : number;

  /**
   * The nodes of the graph, representing subjects in the relation network.
   */
  @validateAs({array: "object"}) // TODO: refine
  public nodes : MessageRelationNode[];

  /**
   * The edges of the graph, representing relations.
   * NOTE1: While the relations are "undirected", their roles are relative to a
   * particular direction, and their labels must respect this.
   * NOTE2: There can be many of these edges between a given pair of nodes, so
   * long as they don't have the exact same role set.
   */
  @validateAs({array: "object"}) // TODO: refine
  public edges : MessageRelationEdge[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/subjects/relation-graph-response.ts